import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

//
function SEO({ description, lang, image, slug, meta, title, canonical }) {
    const { site } = useStaticQuery(
        graphql`
            query SEO_QUERY {
                site {
                    siteMetadata {
                        title
                        description
                        author
                    }
                }
            }
        `
    );
    const metaDescription = description || site?.siteMetadata?.description;

    const siteUrl = `${process.env.SITE_URL}/${
        // To remove duplicate slashes
        slug?.replace(/^\/(.*)/, '$1') || '' || ''
    }`;
    const canonicalUrl = canonical
        ? canonical
        : `/${
              // To remove duplicate slashes
              slug?.replace(/^\/(.*)/, '$1') || ''
          }`;

    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            bodyAttributes={{
                class: 'fs-unmask',
            }}
            title={title}
            titleTemplate={`%s | ${site.siteMetadata.title}`}
            link={[
                {
                    rel: 'canonical',
                    href: canonicalUrl,
                },
            ]}
            meta={[
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    property: `og:image`,
                    content: image?.url,
                },
                {
                    property: `og:url`,
                    content: siteUrl,
                },
                {
                    property: `og:site_name`,
                    content: site.siteMetadata.title,
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: site.siteMetadata.author,
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
                {
                    name: `twitter:image`,
                    content: image?.url,
                },
                process.env.GATSBY_ACTIVE_ENV === 'production' && {
                    name: `facebook-domain-verification`,
                    content: 'vevp1uhneozkuzkwk5ktfn2zcg2it5',
                },
            ]
                .filter(Boolean)
                .concat(meta)}
        >
            <script type="application/ld+json">
                {JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'Organization',
                    url: 'https://adam.ai',
                    logo: 'https://adamdotai-website-v4.cdn.prismic.io/adamdotai-website-v4/6e593c83-d4ab-4f3b-906a-44b6361c84f2_Wordmark%20&%20Symbol%20Landscape.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&q=50',
                    image: 'https://adamdotai-website-v4.cdn.prismic.io/adamdotai-website-v4/6e593c83-d4ab-4f3b-906a-44b6361c84f2_Wordmark%20&%20Symbol%20Landscape.svg?ixlib=gatsbyFP&auto=compress%2Cformat&fit=max&q=50',
                    name: 'adam.ai',
                    description:
                        'Are you ready to make your meetings more productive? Our intelligent meeting management tool can help!',
                    telephone: '+00-00-000-0000',
                })}
            </script>
        </Helmet>
    );
}

SEO.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``,
};

export default SEO;
